import popApi from "../../components/api/popApi";
import axios from "../../components/api/editapi";
import popReportApi from '../../components/api/popReportApi';

const setAuthToken = token => {
    if (token) {
        popApi.defaults.headers.common.Authorization = token;
        popReportApi.defaults.headers.common.Authorization = token;

    } else {
        delete popApi.defaults.headers.common.Authorization;
        delete popReportApi.defaults.headers.common.authorization;
    }
};
export default setAuthToken;
